import { render, staticRenderFns } from "./BulkActionOptions.vue?vue&type=template&id=0fa43557&"
import script from "./BulkActionOptions.vue?vue&type=script&lang=js&"
export * from "./BulkActionOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports